import PropTypes from 'prop-types';

const ChevronIcon = ({ arrowUp }) => {  // Destructuring arrowUp correctly
    return arrowUp ? (
        // Chevron Up
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <mask id="mask0_2531_4723" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
          <rect width="20" height="20" transform="matrix(0 1 1 0 0 0)" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_2531_4723)">
          <path d="M16.9727 12.9746L9.99806 6L3.02344 12.9746L4.04881 14L9.99806 8.05057L15.9473 14L16.9727 12.9746Z" fill="var(--primary-icon-color)"/>
        </g>
      </svg>
    ) : (
        // Chevron Down
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <mask id="mask0_2531_3721" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                <rect y="20" width="20" height="20" transform="rotate(-90 0 20)" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2531_3721)">
                <path d="M16.9727 7.02538L9.99806 14L3.02344 7.02538L4.04881 6L9.99806 11.9494L15.9473 6L16.9727 7.02538Z" fill="var(--primary-icon-color)" />
            </g>
        </svg>
    );
};
ChevronIcon.propTypes = {
  arrowUp: PropTypes.bool,
}

export default ChevronIcon;
